import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDetail, saveWidgetSettings } from '../../redux/dashboardSlice.js';
import DetailSidebarSettings, { SIDEBAR_SETTING_TYPES } from '../../settings_sidebar/DetailSidebarSettings.jsx';
import { useSetArrayEntityAttribute } from '../../hooks/useSetArrayEntityAttribute.js';
import Errors from '../../../common/Errors.jsx';
import TextSetting from '../../settings_sidebar/ag_chart/components/TextSetting.jsx';
import FilterSetting from './FilterSetting.jsx';
import Button from '../../../bootstrap/Button.jsx';
import SettingsSection from '../../settings_sidebar/common/SettingsSection.jsx';
import ColorPickerSetting from '../../settings_sidebar/ag_chart/components/ColorPickerSetting.jsx';

function ButtonSettings({ ...props }) {
  const filters = props.selectedObject?.filters || [];

  return (
    <>
      <SettingsSection>
        <TextSetting {...props} descPrefix='button_' attr='name' label={I18n.t('name')} />
        <TextSetting {...props} descPrefix='button_' attr='description' label={I18n.t('description')} />
        <ColorPickerSetting {...props} descPrefix='button_' attr='color' label={I18n.t('color')} /> 
      </SettingsSection>
      <hr />
      {filters.map((_, index) => <>
        {index !== 0 && <hr />}
        <FilterSetting {...props} filterIndex={index} />
      </>)}
      <div className='mt-1 pull-right'>
        <Button type='danger' onClick={() => props.setAttribute('filters', filters.filter((_, i) => i !== filters.length - 1))} className='mr-1'>
          {I18n.t('delete_filter')}
        </Button>
        <Button onClick={() => props.setAttribute('filters', [...filters, { id: Math.random().toString(36).substring(7) }])}>
          {I18n.t('add_filter')}
        </Button>
      </div>
    </>
  )
}


function ButtonOptions({ widgetId, selectedButton }) {
  const errors = useSelector(state => state.dashboard.configErrors?.[widgetId]?.buttons?.[selectedButton?.id]) || {}
  const setAttribute = useSetArrayEntityAttribute({widgetId, entitiesSettingId: 'buttons', entityId: selectedButton.id });

  return (
    <>
      <Errors errors={errors} />
      <ButtonSettings {...{ widgetId, selectedObject: selectedButton, setAttribute }} hideDescription={true} />
    </>
  )
}

function AdvancedFilterButtonSidebar({ widgetId, selectedButton, setOpenedButton }) {
  const dispatch = useDispatch();

  const saveSettings = () => {
    dispatch(saveWidgetSettings());
    setOpenedButton(null);
    dispatch(closeDetail());
  }

  return (<>
    {selectedButton && 
      <DetailSidebarSettings onClose={() => setOpenedButton(null)} validate={() => true} saveSettings={saveSettings} sidebarId={`${SIDEBAR_SETTING_TYPES.advanced_filter_button}-${selectedButton.id}`}>
        <h4 className='mb-1'>{selectedButton.name ? I18n.t('edit_button_named', {name: selectedButton.name}) : I18n.t('edit_button_id', {id: selectedButton.id})}</h4>
        <ButtonOptions widgetId={widgetId} selectedButton={selectedButton} errors={{}} />
      </DetailSidebarSettings>
    }
  </>
  )
}

export default AdvancedFilterButtonSidebar;